export enum ContractPriceMethodType {
  ServiceAreas = 'ServiceAreas',
  Locations = 'Locations',
  Vehicle = 'Vehicle',
  DeliveryAmount = 'DeliveryAmount'
  // Distance = 'Distance'
}
